// extracted by mini-css-extract-plugin
export default {"iconDotLoader":"IconDotLoader_iconDotLoader__OMZTF","dot":"IconDotLoader_dot__dsaE5","loader":"IconDotLoader_loader__6EQjX"};